import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'
import callapiobj from '../../../Common/api';
import ShapeLeft from '../../../../images/ShapeLeft.svg';
import ShapeRight from '../../../../images/ShapeRight.svg';
import {base_url} from '../../../Common/api';
import FirstPage from '../../../../images/firstPageIcon.svg';
import LastPage from '../../../../images/lastPageIcon.svg';




var url =  window.location.hostname;
var port = window.location.port;
// const Heading = [['ID', 'Warehouse', 'Brand', 'Area Code','Nearby Area Code' ]]
const Heading = [['ID', 'Area Code','Nearby Area Code' ]]




class ItemMasterComponent extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.fetchBinData = this.fetchBinData.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);


    this.state = {
    loading_overlay: false, 
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      selectedBrands: [],
      startCount: 0,
      endCount: 0,
      entriesPerPage: 10,
      showInvalidItem: false,
      selectedBrands:[],
      isDownloading: false,
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      showResponseData: false,
      showBaseResponseData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      loading: false,
      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,
      brandList: [],
      brand_name: "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      startIndex: 0,
      endIndex: 0,
      loadingText: 'Loading...',
  
  
    };
  }


  componentDidMount(){
  this.fetchBinData();
  this.getBrand();
  }

  handleChangeEvent = (evt) =>{
    this.setState({[evt.target.name]: evt.target.value})
    console.log(evt.target.name, evt.target.value)

  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = Util.getCookie('token');
      var location = Util.getCookie('selectedLocation');
      var username = Util.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

 

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));  
  }

  getBrand = () => {
    
    API.get('/tax/v1/filter/brands')
    .then((response) => response.data)

    .then((data) => {

      console.log("brand",data);
      const transformedBrands = data.data.map((brand) => ({
          label: brand.name,
          value: brand.name,
      }));
      this.setState({ brandList: transformedBrands });
    })

    .then(async () => {
      
    });
  }

   handleSearchInput = (e) => {
    const searchValue = e.target.value;
    this.setState({ searchTerm: searchValue }); // optional, for reuse in pagination
    if(searchValue == ""){
      this.fetchBinData(1, searchValue);
    }
     
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.fetchBinData(1, this.state.searchTerm);
    }
  };

 

  fetchBinData(page = 1, searchTerm = ''){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay:true,
        isDownloading: false
      })


    /* const payload={brand: this.state.brand,
     }*/

    const payload = {
      ...(this.state.selectedBrandNames ? { brand: this.state.selectedBrandNames } : {}),
      ...(page == 1 ? {} : {page: page}),
       ...(this.state.entriesPerPage ? { page_size: this.state.entriesPerPage } : {}),
        ...(searchTerm ? { search: searchTerm } : {}),

    };

     callapiobj.get('/tax/v1/group/product/mapped', { param: payload })
   /* API.get('/tax/v1/group/product/mapped?', { param: payload })*/

      .then(response => response.data)

      .then(data => {

         console.log("All Data",data);

         // if (err) throw err;
         // if (err) throw err;\
        if(data.status == true){
          const { data: posts, pagination } = data;
          const perPage = Math.ceil(pagination.count / pagination.total_pages);

          // Calculate startIndex and endIndex based on pagination data
          const startIndex = (pagination.current_page - 1) * perPage + 1;
          const endIndex = Math.min(pagination.current_page * perPage, pagination.count);


         this.setState({posts: data.data, currentPage: pagination.current_page,
          totalPages: pagination.total_pages, totalItems: pagination.count,
          startIndex: startIndex,perPage: perPage,
          endIndex: endIndex, startCount: pagination.showing.start, endCount: pagination.showing.end })
        }else{
          this.setState({
            posts: [],
            totalPages: 1,
            currentPage: 1,
            startIndex: 0,
            endIndex: 0,
            totalItems: 0,
            startCount: 0,
            endCount: 0



          })
        }
          

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         console.log(this.state.tableRows);

      });
  }
   handlePageChange(pageNumber) {
    this.fetchBinData(pageNumber);
  }


 
 

  assemblePosts = () => {
    const posts = this.state.posts.map((post) => {
      const taxGroup =
        post.tax_group_mapping && post.tax_group_mapping.tax_group
          ? post.tax_group_mapping.tax_group
          : {};

      const taxType =
        taxGroup.tax_type && taxGroup.tax_type.tax_type
          ? taxGroup.tax_type.tax_type
          : '';

      const taxCommunity =
        taxGroup.tax_community && taxGroup.tax_community.name
          ? taxGroup.tax_community.name
          : '';

      const taxGroupName = taxGroup.group || '';
      const taxDescription = taxGroup.description || '';

      const taxRegion =
        post.tax_region && post.tax_region.length > 0 &&
        post.tax_region[0].tax_region && post.tax_region[0].tax_region.state_name
          ? post.tax_region[0].tax_region.state_name
          : '';

      return {
        item_code: post.sku7_code,
        item_desc: post.lb_sku_product_name,
        tax_type: taxType,
        tax_group: taxGroupName,
        tax_community: taxCommunity,
        tax_region: taxRegion,
        //tax_desc: taxDescription,
         tax_desc: (
          <div className="text-wrap-cell">
            {taxDescription}
          </div>
        ),
      };
    });

    this.setState({
      loading_overlay: false,
      mappedPosts: posts
    });

    return posts;
  };

   /*downloadExcel = async() => {
     const token = Util.accessCookie("token");
     const url = `${base_url}/tax/v1/group/product/mapped/download?brand=`+this.state.brand_name;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "tax_group_report.csv"); // Set filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };*/
  downloadExcel = async () => {
    this.setState({ isDownloading: true });
    const token = Util.accessCookie("token");
    let url = `${base_url}/tax/v1/group/product/mapped/download`;
    
    // Append brand parameter only if it exists
    if (this.state.selectedBrandNames) {
        url += `?brand=${this.state.selectedBrandNames}`;
    }

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "mapped_item_report.csv"); // Set filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
       this.setState({ isDownloading: false });
    } catch (error) {
      console.error("Error downloading file:", error);
       this.setState({ isDownloading: false });
    }
  };



 
 
  render() {
    const { handleSubmit, reset, t } = this.props;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;
    const { tableRows, currentPage, totalPages, totalItems, startIndex, endIndex, loading_overlay } = this.state;



    const data = {

      columns: [


        {

          label:'Item Code',

          field:'item_code',
          sort: '',
          width: 150,

        },

        {

          label:'Item Desc',

          field:'item_desc',
          sort: '',
          width: 220,

        },
         {

          label:'Tax Type',

          field:'tax_type',
          sort: '',
          width: 180,

        },
         {

          label:'Tax Group',

          field:'tax_group',
          sort: '',
          width: 150,

        },
         {

          label:'Tax Community',

          field:'tax_community',
          sort: '',
          width: 150,

        },
        {

          label:'Tax Region',

          field:'tax_region',
          sort: '',
          width: 150,

        },
        {

          label:'Tax Desc',

          field:'tax_desc',
          sort: '',
          width:250,

        },
        

        //  {

        //   label:'Ranking',

        //   field:'ranking',
        //   sort: 'asc',

        // },


        

      ],

      rows:this.state.tableRows,

    }


   

    return (
      <Col xl={12}>
         {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>

         <Overlay>
            <form className="form" onSubmit={handleSubmit}>
             <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
            </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Brand</span>
                <div style={{ position: 'relative' }}>

                  <Select
                    isMulti
                    options={this.state.brandList}
                    value={this.state.selectedBrands}
                    onChange={(selectedOptions) => {
                      const isEmpty = !selectedOptions || selectedOptions.length === 0;

                      this.setState({
                        selectedBrands: selectedOptions,
                        selectedBrandNames: isEmpty
                          ? ''
                          : selectedOptions.map(option => option.value).join(','),
                      }, () => {
                        if (isEmpty) {
                          this.fetchBinData(); // Call your function if selection is empty
                        }
                      });
                    }}
                    closeMenuOnSelect={false}
                    menuPlacement="auto"
                    styles={{
                      valueContainer: (base) => ({
                        ...base,
                        maxHeight: 80,
                        overflowY: 'auto',
                        flexWrap: 'wrap',
                      }),
                      control: (base, state) => ({
                        ...base,
                        minHeight: 38,
                        overflow: 'hidden',
                        flexWrap: 'wrap',
                        borderColor: state.isFocused ? '#2684FF' : base.borderColor,
                        boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : base.boxShadow,
                      }),
                      multiValue: (base) => ({
                        ...base,
                        maxWidth: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }),
                    }}
                  />


                </div>
                    </div>

              
              
              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{

                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 6,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      marginRight: '10px', // Add some spacing between buttons
                    }}
                    id="button_view"
                    onClick={() => this.fetchBinData()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View 
                  </Button>
               
              
               </ButtonToolbar>                     
        </div>
            </form>
          </Overlay>


          <div>
            {this.state.selectedBrands.length > 0 && (
              <div>

                {this.state.selectedBrands.map((brand, index) => (
                  <div className="filter-display" key={brand.value}>
                    {brand.label}
                    
                  </div>
                ))}
              </div>
            )}

          </div>

          

          {
            this.state.showFetchBinData  && (

            <div id="masterTableContainer" className = "taxmaster_table" style={{marginTop: 18}}>
            
              

                  <div className="showEntriesContainer" style={{ display: 'flex', alignItems: 'center', width: '75%', float: 'left', marginTop: 5 }}>
                    <span style={{ marginRight: '0.5rem' }}>Show</span>
                    <select
                      id="showEntriesSelect"
                      value={this.state.entriesPerPage}
                      style={{height: 28}}
                      onChange={(e) => {
                        const newLimit = parseInt(e.target.value, 10);
                        this.setState({ entriesPerPage: newLimit }, () => {
                          this.fetchBinData(1, newLimit); // Reset to page 1 when changing page size
                        });
                      }}
                      style={{ marginRight: '0.5rem' }}
                    >
                      {[10, 25, 50, 100].map((num) => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                    <span>entries</span>
                  </div>
                  <div className="showEntriesContainer" style={{ display: 'flex', alignItems: 'center', width: '25%', float: 'left' }}>
                    <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="Search"
                      value={this.state.searchTerm}
                      onChange={this.handleSearchInput}
                      onKeyDown={this.handleKeyDown}
                      id="searchInput"
                    />
                     {this.state.isDownloading ? (
                        <a
                          className="pull-right"
                          style={{
                            fontSize: "17px",
                            paddingRight: "0px",
                            cursor: "pointer",
                            color: "#919193",
             
                            marginLeft: 6
                          }}
                        >
                         
                            <FontAwesomeIcon icon={faSpinner} spin />
                          </a>
                          ) : (
                          <a
                          target="_blank"
                          onClick={(e) => {
                            e.preventDefault(); // prevent default anchor behavior
                            this.downloadExcel();
                          }}
                          className="pull-right"
                          style={{
                            fontSize: "17px",
                            paddingRight: "0px",
                            cursor: "pointer",
                            color: "#919193",
            
                            marginLeft: 6
                          }}
                        >
                            <FontAwesomeIcon icon={faDownload} />
                          </a>

                          )}
                  </div>


             
                <MDBDataTable
                  striped
                  bordered
                  sortable={true}
                  paging={false}
                  searching= {false}
                  scrollX
                  hover
                  data={data}
                  onPageChange={(pageNumber) =>
                    paginationAnalytics(
                      pageNumber.activePage,
                      pageNumber.pagesAmount,
                      'category_master_view',
                      'datatable_pagination_change'
                    )
                  }
                />
              

            {/*<div style={{ overflowX: 'auto' }}>
              <MDBDataTable
              striped
              bordered
              sortable={true}
              paging={false}
              hover
              data={data}
              onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'category_master_view', 'datatable_pagination_change' )}
            />
            </div>*/}
            
            <div className="pagination-container1" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem' }}>
                <div className="pagination-left">
                  <span>Showing {this.state.startCount} to {this.state.endCount} out of {totalItems}</span>
                </div>

                <div className="pagination-right" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {/* First */}
                  <img
                    src={FirstPage}
                    alt="firstPage"
                    style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
                    onClick={() => currentPage !== 1 && this.handlePageChange(1)}
                  ></img>

                  {/* Previous */}
                  <img
                    src={ShapeLeft}
                    alt="Previous"
                    style={{ width: '12px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
                    onClick={() => currentPage !== 1 && this.handlePageChange(currentPage - 1)}
                  />

                  {/* Page Numbers */}
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => {
                    if (
                      pageNum === 1 ||
                      pageNum === totalPages ||
                      (pageNum >= currentPage - 2 && pageNum <= currentPage + 2)
                    ) {
                      return (
                        <span
                          key={pageNum}
                          onClick={() => this.handlePageChange(pageNum)}
                          style={{
                            fontWeight: currentPage === pageNum ? 'bold' : 'normal',
                            color: currentPage === pageNum ? '#FBBB00' : '#000',
                            cursor: 'pointer'
                          }}
                        >
                          {pageNum}
                        </span>
                      );
                    } else if (
                      pageNum === currentPage - 3 ||
                      pageNum === currentPage + 3
                    ) {
                      return <span key={pageNum}>...</span>;
                    } else {
                      return null;
                    }
                  })}

                  {/* Next */}
                  <img
                    src={ShapeRight}
                    alt="Next"
                    style={{ width: '12px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                    onClick={() => currentPage !== totalPages && this.handlePageChange(currentPage + 1)}
                  />

                  {/* Last */}
                  <img
                    src={LastPage}
                    alt="lastPage"
                    style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                    onClick={() => currentPage !== totalPages && this.handlePageChange(totalPages)}
                  ></img>
                </div>
              </div>

          </div>

          )}



        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>

      


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(ItemMasterComponent));